import { axiosFactory } from '../../../../client';
import { BlacklistDownloadResponse } from '../models';
import * as ROUTES from './routes';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/blacklisted-candidates`;
const timeout = 5000;

export const candidateClient = axiosFactory(baseURL, timeout);

export const getCSVTemplateDownloadUrl = () =>
  candidateClient.get<BlacklistDownloadResponse>(`${ROUTES.GET_TEMPLATE_DOWNLOAD_URL}`);
